import { render, staticRenderFns } from "./ColumnConfigurationDeleteDialog.vue?vue&type=template&id=3c20448c&"
import script from "./ColumnConfigurationDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnConfigurationDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports